export function initMegaMenu() {
	const MQ = window.matchMedia('(min-width: 1024px)');

	document.querySelectorAll('.menu-item.has-children').forEach((item) => {
		const trigger = item.querySelector('.mega-menu__trigger');
		const menu = item.querySelector('.mega-menu');
		if (!trigger || !menu) return;

		const subItems = Array.from(item.querySelectorAll('.mega-menu__item.has-teaser'));
		const allItems = Array.from(item.querySelectorAll('.mega-menu__item'));
		const teasers = Array.from(item.querySelectorAll('.mega-menu__teaser'));
		// Explicit "default" teaser (2-level featured card) or, for 3-level
		// product menus, the first category's panel.
		const defaultTeaser =
			item.querySelector('.mega-menu__teaser[data-teaser="default"]') || teasers[0];

		function showDefault() {
			teasers.forEach((t) => t.classList.remove('is-active'));
			subItems.forEach((s) => s.classList.remove('is-active'));
			if (defaultTeaser) defaultTeaser.classList.add('is-active');
		}

		function closeMenu() {
			item.classList.remove('is-open');
			trigger.setAttribute('aria-expanded', 'false');
			showDefault();
		}

		// Click trigger: toggle on all breakpoints, only one open at a time.
		trigger.addEventListener('click', () => {
			const isOpen = item.classList.contains('is-open');
			document.querySelectorAll('.menu-item.has-children.is-open').forEach((openItem) => {
				openItem.classList.remove('is-open');
				const t = openItem.querySelector('.mega-menu__trigger');
				if (t) t.setAttribute('aria-expanded', 'false');
			});
			if (!isOpen) {
				item.classList.add('is-open');
				trigger.setAttribute('aria-expanded', 'true');
			}
		});

		// Desktop: hovering a category swaps the right-column teaser/panel and
		// highlights the active category. Categories without their own teaser fall
		// back to the default (top-level) teaser.
		allItems.forEach((subItem) => {
			subItem.addEventListener('mouseenter', () => {
				if (!MQ.matches) return;
				const idx = subItem.dataset.teaserIndex;
				const target =
					idx !== undefined
						? item.querySelector(`.mega-menu__teaser[data-teaser="${idx}"]`)
						: null;
				if (!target) {
					showDefault();
					return;
				}
				teasers.forEach((t) => t.classList.remove('is-active'));
				subItems.forEach((s) => s.classList.remove('is-active'));
				subItem.classList.add('is-active');
				target.classList.add('is-active');
			});
		});

		// Leaving the whole panel resets to the default teaser/panel.
		menu.addEventListener('mouseleave', () => {
			if (!MQ.matches) return;
			showDefault();
		});

		// Desktop: click outside closes the menu.
		document.addEventListener('click', (e) => {
			if (MQ.matches && !item.contains(e.target)) {
				closeMenu();
			}
		});
	});
}
